export default __webpack_public_path__ + "images/f6fd2a10dc863ef61da5bd20360030be-adoption-dog-666.gif";